import { observable, computed, action } from "mobx";
import { ROUTE_FROM_PEGNI, ROUTE_RICEVUTE, ROUTE_RICEVUTE_DETTAGLIO } from "../assets/frontendRouting";
import {  PATH_TIPOLOGICHE, PATH_DOWNLOAD_FILE_DUPLO, PATH_RICEVUTE_DUPLO } from "../config/presdoc-fe-config";

class RicevuteDuploStore {

  constructor(root) {   
    this.service = root.service
    this.serviceDownload = root.serviceDownload;
    this.userInfoStore = root.userInfoStore;
    this.qualificheStore= root.qualificheStore;
    this.routingStore = root.routingStore;
    this.initialPagination = {
      start: 0,
      end: 10,
      page:1,
      limit: 10,
      pageCount: 5,
      displayPage: 1
    }
  }

  @observable filtriRicerca = undefined;
  @observable filtriRicercaStored = undefined;
  @observable ricevute = undefined;
  @observable loading = false;
  @observable pagination = this.initialPagination;
  

  @action
  updatePagination(start,end,page){
    this.pagination = {
      ...this.pagination,
      start,
      end,
      page
    }
  }

  @action
  initPagination(){
    this.pagination = {
      ...this.initialPagination
    }
  }

  @action
  clearRicevute() {
    this.ricevute = undefined;
  }

  @action
  clearFiltriRicerca() {
    this.filtriRicerca = undefined;
  }

  @action
  fetchRicevute(params){
    this.clearRicevute();
    this.initPagination();
    this.loading = true;
    this.filtriRicerca = {
      ...params
    };
    
   // params.codiceFiscaleRiferimento = this.userInfoStore.userInfo.codiceFiscale;   
    //params.identificativoUtenza = this.qualificheStore.qualificaCittadino;
    params.codiceFiscaleRiferimento = this.qualificheStore.codiceFiscaleRiferimento(); 
    params.identificativoUtenza =  this.qualificheStore.qualifica.identificativoUtenza;
    this.ricevute=undefined;
    return new Promise((resolve, reject) => {
    this.service.doAjax('POST', `${PATH_RICEVUTE_DUPLO}`, params).then(response => {  
      this.loading = false;
      
       if(response.success) {
         this.ricevute = response.result.dupliRestituiti;
         resolve("Promise resolved");
        }
    });
  })
  }

 
  downloadFile(params) {
    params.codiceFiscaleRiferimento = this.qualificheStore.codiceFiscaleRiferimento(); 
    params.identificativoUtenza =  this.qualificheStore.qualifica.identificativoUtenza;
    this.serviceDownload.doAjax('POST', `${PATH_DOWNLOAD_FILE_DUPLO}`, params);
  }

 }

export default RicevuteDuploStore;